var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-paper',{attrs:{"z-depth":1}},[_c('ChannelItem',{attrs:{"channelId":_vm.channel._id,"mediaId":_vm.mediaId,"panel":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }